function dispatchEvent(eventName) {
  const event = document.createEvent('Event');
  event.initEvent(eventName, true, true);
  return document.dispatchEvent(event);
}

export default dispatchEvent;



// WEBPACK FOOTER //
// ./public/js/utils/dispatchEvent.js